<template>
  <ScrollUp :type="ctaVariant"/>
  <div class="etx-container Container pt-50 pb-50">
    <div class="etx-center Center">

      <div class="etx-flex Flex tab-s:gv-0">
        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-8">

          <NuxtPageDependency>
            <Breadcrumb :links="breadcrumb" />
          </NuxtPageDependency>

          <div class="etx-text Text" :class="entranceClassList">
            <h1>{{ title }}</h1>
            <p v-if="subline" class="font-h1 alt">{{ subline }}</p>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="etx-container Container pt-0">
    <div class="etx-center Center">

      <div
        class="FixedRatio ratio-3-2 falling-off-left falling-off-right desk-l:falling-off-max-left desk-l:falling-off-max-right"
        :class="entranceClassList">

        <div class="Brandshape" data-color-main="primary" data-color-accent="secondary">
          <svg width="208" height="208">
            <use xlink:href="#brandshape-diagonal"></use>
          </svg>
        </div>

        <div class="etx-background-media BackgroundMedia" :class="backgroundMediaClassList">

          <div class="etx-media Media">
            <MediaImage :media="image" imageStyle="image_3_2" />
          </div>

        </div>

      </div>

    </div>
  </div>

  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <BlokkliField :list="paragraphs" name="field_paragraphs" />
  </BlokkliProvider>

  <LocationSearch v-if="showLocationSearch && blokkliProps?.canEdit" />

</template>

<script lang="ts" setup>
import type { NodeApprenticeshipsFragment } from '#graphql-operations'

const breadcrumb = useBreadcrumbLinks()

const props = defineProps<{
  uuid: string
  title: string
  subline: string
  image: {
    url: {
      path: string
    }
    alt: {
      alt: string
    }
    title: string
  }
  paragraphs?: NodeApprenticeshipsFragment['paragraphs']
  blokkliProps: NodeApprenticeshipsFragment['blokkliProps']
  showLocationSearch?: boolean
  verticalAlign: string
  isFrontpage?: boolean
  ctaVariant?: string
}>()

if (props?.isFrontpage) {
  useHead({
    htmlAttrs: {
      class: 'home',
    },
  });
}

const entranceClassList = computed(() => {
  const classList = []
  classList.push('will-appear', 'move-up')
  return classList
})

const backgroundMediaClassList = computed(() => {
  
  if (props?.verticalAlign && props?.verticalAlign != 'center') {
    return props?.verticalAlign
  }

  if (props?.image?.verticalAlign && props?.image?.verticalAlign != 'center') {
    return props?.image?.verticalAlign
  }

  return ''
})

</script>
